import React from 'react'
import { CCard, CCardBody, CCardHeader } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilShieldAlt } from '@coreui/icons'
import { Link } from 'react-router-dom'
import moment from 'moment'

const InfoRow = ({ label, value }) => (
  <div className="d-flex justify-content-between mb-2">
    <span className="text-medium-emphasis">{label}</span>
    <span>{value || '-'}</span>
  </div>
)

const GameInformationCard = ({ gameInformation }) => {
  const season =
    gameInformation.season_start && gameInformation.season_end
      ? `${moment(gameInformation.season_start).format('MMM D, YYYY')} - ${moment(
          gameInformation.season_end,
        ).format('MMM D, YYYY')}`
      : null

  return (
    <CCard className="mb-4">
      <CCardHeader className="d-flex justify-content-between align-items-center">
        Game Information
      </CCardHeader>
      <CCardBody>
        <InfoRow label="Hub ID" value={gameInformation.hub_id} />
        <InfoRow label="Game ID" value={gameInformation.game_id} />
        <InfoRow label="Game Name" value={gameInformation.game_name} />
        <InfoRow label="Game Type" value={gameInformation.game_type} />
        <InfoRow label="Sport" value={gameInformation.sport} />
        <InfoRow label="Team Size" value={gameInformation.team_size} />
        <InfoRow label="Selection Mode" value={gameInformation.selection_mode} />
        <InfoRow label="Salary Cap" value={gameInformation.salary_cap} />
        <InfoRow label="Trades" value={gameInformation.trades} />
        <InfoRow label="Salary Symbol" value={gameInformation.salary_symbol} />
        <InfoRow label="Privacy" value={gameInformation.privacy} />
        <InfoRow label="Timezone" value={gameInformation.timezone} />
        <InfoRow label="Terms & Conditions" value={gameInformation.terms_condition} />
        <InfoRow label="Season" value={season} />
        <InfoRow label="Point System" value={gameInformation.point_system_type} />
      </CCardBody>
    </CCard>
  )
}

export default GameInformationCard
